module.exports = __webpack_public_path__ + "static/alwaysmavs-a7e8feadb9175c5a82abe13c843ecc73.png";